import styled from "styled-components";


export const Container = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 10px;
    background-color: ${({ theme }) => theme.colors.primary};
    padding: 4px 10px;
    border-radius: 6px;
    cursor: pointer;
`;

export const Text = styled.span`
    color: ${({ theme }) => theme.colors.extralightGray};
    margin: 0px
`;
